import { FormType, useFormState, ValidationDisplayPolicy } from "@hex-insights/forms";

export type SearchFormValues = {
	search: string;
};

export const initialSearchFormValues: SearchFormValues = {
	search: "",
};

export function useSearchFormState() {
	return useFormState({
		initialFormValues: initialSearchFormValues,
		formType: FormType.Standing,
		validationDisplayPolicy: ValidationDisplayPolicy.none,
	});
}
